import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
import { SectionHeading } from "components/misc/Headings";

export const ContentWithPaddingXl = tw.div`max-w-screen-xl mx-auto`;

// Styled HeaderRow with conditional border visibility
const HeaderRow = styled.div`
  ${tw`flex justify-between items-center flex-col xl:flex-row`}
  ${({ isCenter }) =>
    isCenter && tw`justify-center text-center`} /* Center alignment */
  ${({ borderHide }) =>
    borderHide ? tw`border-none` : tw`border-b-2 border-ncc`} /* Hide border */
`;

// Styled Header with conditional text alignment
const Header = styled(SectionHeading)`
  ${tw`text-right`}
  ${({ isCenter }) => isCenter && tw`text-center`} /* Text alignment */
`;

const HighlightedText = tw.span`bg-ncc text-gray-100 px-4 transform -skew-x-12 inline-block text-left`;

const BgTitle = ({ text, isCenter = false, borderHide = false }) => {
  const heading = (
    <>
      <HighlightedText>{text}</HighlightedText>
    </>
  );

  return (
    <HeaderRow isCenter={isCenter} borderHide={borderHide}>
      <Header isCenter={isCenter}>{heading}</Header>
    </HeaderRow>
  );
};

export default BgTitle;
